"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePeriodMenuInteractor = void 0;
const core_1 = require("@veeam/core");
const isOneDay_1 = require("../../helpers/isOneDay");
class DatePeriodMenuInteractor extends core_1.Interactor {
    constructor(value, listener, config) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        super();
        this.listener = listener;
        this.config = config;
        this.didApplySelect = () => {
            var _a, _b, _c, _d, _e, _f;
            if (!this.form.validateAndDisplayErrors()) {
                return;
            }
            const values = this.form.getValue();
            if (values.type === 'date' && values.date) {
                (_b = (_a = this.listener).onSubmit) === null || _b === void 0 ? void 0 : _b.call(_a, [values.date]);
                return;
            }
            if (values.type === 'period' && values.startDate && values.endDate) {
                const end = new Date(values.endDate);
                end.setHours(24, 0, 0, 0);
                (_d = (_c = this.listener).onSubmit) === null || _d === void 0 ? void 0 : _d.call(_c, [values.startDate, new Date(end.valueOf() - 1)]);
                return;
            }
            (_f = (_e = this.listener).onSubmit) === null || _f === void 0 ? void 0 : _f.call(_e, []);
        };
        let initType = !value.length ? 'all' : value.length === 1 ? 'date' : 'period';
        if (value && value[0] && value[1] && (0, isOneDay_1.isOneDay)(value[0], value[1])) {
            initType = 'date';
            value = value.slice(0, 1);
        }
        const now = new Date();
        const defaultDate = ((_a = this.config) === null || _a === void 0 ? void 0 : _a.defaultInitDate) || now;
        const defaultStartDate = ((_b = this.config) === null || _b === void 0 ? void 0 : _b.defaultInitFromDate) || now;
        if (((_c = this.config) === null || _c === void 0 ? void 0 : _c.defaultInitToDate) &&
            ((_d = this.config) === null || _d === void 0 ? void 0 : _d.defaultInitFromDate) &&
            ((_e = this.config) === null || _e === void 0 ? void 0 : _e.defaultInitToDate) < ((_f = this.config) === null || _f === void 0 ? void 0 : _f.defaultInitFromDate)) {
            console.warn('DatePeriodMenu Error: the value of "defaultInitFromDate" property must be greater than the value of "defaultInitToDate" property.');
        }
        const defaultEndDate = ((_g = this.config) === null || _g === void 0 ? void 0 : _g.defaultInitToDate) ||
            new Date(defaultStartDate.getTime() + 1000 * 24 * 60 * 60);
        this.form = new core_1.Form(new core_1.Model({
            type: initType,
            date: (initType === 'date' && value[0]) || defaultDate,
            startDate: (initType === 'period' && value[0]) || defaultStartDate,
            endDate: (initType === 'period' && value[1]) || defaultEndDate
        }), {
            validationSchema: {
                type: [(0, core_1.required)()],
                date: [(0, core_1.conditions)({ type: 'date' }, (0, core_1.required)((_h = this.config) === null || _h === void 0 ? void 0 : _h.requireErrorText))],
                startDate: [
                    (0, core_1.conditions)({ type: 'period' }, (0, core_1.required)((_j = this.config) === null || _j === void 0 ? void 0 : _j.requireErrorText))
                ],
                endDate: [
                    (0, core_1.conditions)({ type: 'period' }, (0, core_1.required)((_k = this.config) === null || _k === void 0 ? void 0 : _k.requireErrorText))
                ]
            }
        });
    }
}
exports.DatePeriodMenuInteractor = DatePeriodMenuInteractor;
//# sourceMappingURL=DatePeriodMenuInteractor.js.map